import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import { useSmartBanner } from '@presentation/context/SmartBannerContextProvider';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Wrapper } from './styles';

export type ListPageHeaderBreadcrumb = {
	label: string;
	url?: string;
};

export type ListPageHeaderProps = {
	breadcrumbs?: ListPageHeaderBreadcrumb[];
	title: string;
	count?: number;
};
export const ListPageHeader = (props: ListPageHeaderProps) => {
	const { breadcrumbs, title, count } = props;
	const navigate = useNavigate();

	const { isOpen } = useSmartBanner();
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<Wrapper isSmartBannerOpen={isOpen}>
			<Container maxWidth='xl'>
				<Box paddingLeft={0}>
					{breadcrumbs && breadcrumbs?.length > 0 && (
						<Breadcrumbs
							style={{
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{breadcrumbs.map((item) =>
								item.url ? (
									<Link
										fontSize={14}
										underline='hover'
										color={theme.colors.brand}
										onClick={() => navigate(item.url || '/')}
										href={item.url}
										key={item.label}
									>
										<Trans i18nKey={item.label} />
									</Link>
								) : (
									<Typography
										fontSize={14}
										color={theme.colors.descriptionText}
										key={item.label}
										style={{
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										<Trans i18nKey={item.label} />
									</Typography>
								)
							)}
						</Breadcrumbs>
					)}
				</Box>
				<Typography
					component='h1'
					color={theme.colors.text}
					sx={{
						fontSize: { xs: 28, md: 40 },
						fontWeight: 800,
						lineHeight: 1.1,
						letterSpacing: '-0.02em',
						mt: 2.5,
						mb: 1,
					}}
				>
					<Trans i18nKey={title} />
				</Typography>
				<Typography fontSize={14} fontWeight={500} color={theme.colors.descriptionText}>
					{`${count} ${t('components.listPageHeader.itemsCount')}`}
				</Typography>
			</Container>
		</Wrapper>
	);
};
